import React, { createContext, useContext, useState, useCallback } from 'react';

const ToastContext = createContext();

export function useToast() {
  return useContext(ToastContext);
}

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const show = useCallback((message, type = 'error') => {
    const id = Date.now();
    setToasts(t => [...t, { id, message, type }]);
    setTimeout(() => setToasts(t => t.filter(x => x.id !== id)), 4000);
  }, []);

  const toast = useCallback((msg) => show(msg, 'success'), [show]);
  const toastError = useCallback((msg) => show(msg, 'error'), [show]);

  return (
    <ToastContext.Provider value={{ toast, toastError }}>
      {children}
      <div style={{
        position: 'fixed', bottom: 'calc(80px + var(--tg-safe-bottom, 0px))',
        left: 16, right: 16, zIndex: 99999,
        display: 'flex', flexDirection: 'column', gap: 8,
        pointerEvents: 'none',
      }}>
        {toasts.map(t => (
          <div key={t.id} style={{
            padding: '12px 16px', borderRadius: 12,
            background: t.type === 'error' ? '#FF453A' : '#30D158',
            color: '#fff', fontSize: 14, fontWeight: 600,
            textAlign: 'center', pointerEvents: 'auto',
            animation: 'fadeInUp 0.25s ease',
            boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
          }}>
            {t.message}
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}
